/**
 * Knowledge Center design system — colors & type from the design board.
 * Use these exact values across KC home, search, category, and article pages.
 */
export const KC_COLORS = {
  primaryNavy: '#0A1D3A',
  navy700: '#112B4D',
  teal: '#009BAA',
  tealLight: '#E6F7F6',
  lightGrey: '#F4F6F8',
  gray600: '#6B7280',
  successGreen: '#22C55E',
  warningAmber: '#F59E08',
  white: '#FFFFFF',
  border: '#E5E7EB',
};

/** Tailwind-friendly class snippets for Inter type scale */
export const KC_TYPE = {
  h1: 'font-semibold text-[40px] leading-[48px] tracking-[0.5px]',
  h1Mobile: 'font-semibold text-[28px] leading-[36px] tracking-[0.5px] md:text-[40px] md:leading-[48px]',
  h2: 'font-semibold text-[28px] leading-[36px] tracking-[0.25px]',
  h2Mobile: 'font-semibold text-[22px] leading-[30px] tracking-[0.25px] md:text-[28px] md:leading-[36px]',
  h3: 'font-semibold text-[20px] leading-[28px] tracking-normal',
  body: 'font-normal text-[16px] leading-[24px]',
  caption: 'font-normal text-[12px] leading-[16px]',
};
